import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { useTranslation } from 'react-i18next'
import EditIcon from '@mui/icons-material/Edit'
import { useNavigate } from 'react-router-dom'
import TableBackdrop from '../../../TableUI/TableBackdrop'
import Pagination from '../../../Pagination/Pagination'
import TableActions from '../../../TableUI/TableActions'
import { Typography } from '@mui/material'
import CurrencyValue from '../../../TableUI/CurrencyValue'
import DatetimeValue from '../../../TableUI/DatetimeValue'
import PreviewIcon from '@mui/icons-material/Preview'
import { MISCELLANEOUS__CREATE } from '../../../../enums/Caps'
import useHasPermissions from '../../../../hooks/useHasPermissions'


export default function MiscellaneousTable({
    data,
    pages = 1,
    page = 1,
    loading = false,
    handleOnPageChange
}) {
    const { t } = useTranslation()

    const hasPermissions = useHasPermissions()
    
    const navigate = useNavigate()

    const handleNavigate = (view) => {
        navigate(view)
    }

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('Type')}</TableCell>
                            <TableCell>{t('Transaction ID')}</TableCell>
                            <TableCell>{t('Created by')}</TableCell>
                            <TableCell align="right">{t('Amount')}</TableCell>
                            <TableCell>{t('Comments')}</TableCell>
                            <TableCell align="center">{t('Created at')}</TableCell>
                            <TableCell align="center">{t('Settled')}</TableCell>
                            <TableCell align="right">&nbsp;</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && data.length ? data.map((row, idx) => (
                            <TableRow
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    <Typography noWrap>{row.type_}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography noWrap>{row.transaction ? row.transaction.transaction_id : ''}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography noWrap>{row.created_by ? row.created_by.email : ''}</Typography>
                                </TableCell>
                                <TableCell align="right">
                                    {row.currency ? <CurrencyValue amount={row.amount} currency={row.currency} /> : ''}
                                </TableCell>
                                <TableCell>{row.comments}</TableCell>
                                <TableCell align="center">
                                    <DatetimeValue date={row.created_at} />
                                </TableCell>
                                <TableCell align="center">
                                    <DatetimeValue date={row.settled_at} />
                                </TableCell>
                                <TableCell align="right">
                                    {!row.settled_at ? <TableActions actions={[
                                        {
                                            id: `edit-${row.id}`,
                                            handleClick: () => { handleNavigate(`${row.id}/edit`) },
                                            icon: hasPermissions(MISCELLANEOUS__CREATE) ? <EditIcon /> : <PreviewIcon />,
                                            title: hasPermissions(MISCELLANEOUS__CREATE) ? t('Edit') : t('View')
                                        }
                                    ]} /> : ''}
                                </TableCell>
                            </TableRow>
                        )) : <TableRow>
                            {
                                loading ? <TableBackdrop open={loading} /> : <TableCell sx={{ textAlign: 'center' }} colSpan={100}>{t('No records found')}</TableCell>
                            }
                        </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            <Pagination
                handleOnPageChange={handleOnPageChange}
                page={page}
                pages={pages}
            />
        </>
    )
}
